module.exports = "../../../../platform/assets/pageMainIcon/jichudanganlei6.svg";